import type { Clinic } from "@/data/clinics-marbella";

interface ClinicCardProps {
  clinic: Clinic;
  position: number;
}

export default function ClinicCard({ clinic, position }: ClinicCardProps) {
  return (
    <article
      id={clinic.slug}
      className="border-t border-rule pt-10"
      aria-labelledby={`${clinic.slug}-name`}
    >
      <div className="flex flex-col gap-1 md:flex-row md:items-baseline md:justify-between">
        <div>
          <div className="eyebrow mb-1">
            Clinic {String(position).padStart(2, "0")}
          </div>
          <h3
            id={`${clinic.slug}-name`}
            className="font-serif text-[1.6rem] leading-tight text-ink"
          >
            {clinic.name}
          </h3>
          <p className="mt-1 text-small text-charcoal/70">
            {clinic.location}
            {clinic.yearEstablished ? ` — ${clinic.yearEstablished}` : ""}
          </p>
        </div>
        <a
          href={clinic.website}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="font-sans text-small"
        >
          Visit website &rarr;
        </a>
      </div>

      <p className="mt-5 text-ink">{clinic.profile}</p>

      <dl className="mt-6 grid gap-x-8 gap-y-4 text-small md:grid-cols-2">
        <div>
          <dt className="eyebrow mb-1">Lab model</dt>
          <dd className="text-ink/90">{clinic.labModel}</dd>
        </div>
        <div>
          <dt className="eyebrow mb-1">Design workflow</dt>
          <dd className="text-ink/90">{clinic.designWorkflow}</dd>
        </div>
        <div>
          <dt className="eyebrow mb-1">Preparation philosophy</dt>
          <dd className="text-ink/90">{clinic.prepPhilosophy}</dd>
        </div>
        <div>
          <dt className="eyebrow mb-1">Ceramist proximity</dt>
          <dd className="text-ink/90">{clinic.ceramistProximity}</dd>
        </div>
        <div>
          <dt className="eyebrow mb-1">International handling</dt>
          <dd className="text-ink/90">{clinic.internationalHandling}</dd>
        </div>
        <div>
          <dt className="eyebrow mb-1">Review profile</dt>
          <dd className="text-ink/90">{clinic.reviewProfile}</dd>
        </div>
      </dl>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        <div className="border-l-2 border-olive pl-4">
          <div className="eyebrow mb-2">Leads on</div>
          <ul className="space-y-1 text-small text-ink/90">
            {clinic.leadsOn.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="border-l-2 border-dustyrose pl-4">
          <div className="eyebrow mb-2">Trails on</div>
          <ul className="space-y-1 text-small text-ink/90">
            {clinic.trailsOn.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
}
